import PropTypes from 'prop-types';

import Flex from 'shopper/components/Flex';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

const GenericError = ({ message }) => (
  <Flex alignItems="center" flexDirection="column" p={4}>
    <Icon name="error-circle" width="40px" size={null} />
    <Text size="size2" textAlign="center" mt={4}>
      {`${message} \nTente novamente em alguns minutos.`}
    </Text>
  </Flex>
);

GenericError.defaultProps = {
  message: 'Ops! Ocorreu um erro inesperado e não possível mostrar essa lista.',
};

GenericError.propTypes = {
  message: PropTypes.string,
};

export default GenericError;
